import { RequestPasswordReset } from '@/features/users/request-password-reset';
import { AuthCard } from '@/shared/ui/auth/auth-card';

export function ForgotPasswordPage() {
    return (
        <div className="flex flex-1 items-start justify-center px-4">
            <AuthCard size="narrow" className="mt-28">
                <RequestPasswordReset />
            </AuthCard>
        </div>
    );
}
